// extracted by mini-css-extract-plugin
export default {"root":"src__components__table__search-bar__root"};